export const EVENT_TYPE = 'EVENT'
export const LIVE_EVENT_ITEM = 'LIVE_EVENT_ITEM'
export const VOD_EVENT_ITEM = 'VOD_EVENT_ITEM'

export const isGen4TitleType = (titleType?: string) =>
  titleType
    ? [
      EVENT_TYPE,
      LIVE_EVENT_ITEM,
      VOD_EVENT_ITEM,
    ].includes(titleType.toUpperCase())
    : false

export const isHoverableTitle = (titleId: string) => !/^amzn1.dv.icid/.test(titleId)

export const isMovie = (titleType: string | undefined): boolean => titleType && titleType.toUpperCase() === 'MOVIE' || false
